export enum ServiceInstance {
  MailReviewService = 'mailReviewService',
  InteractionService = 'interactionService',
  SdrConversationService = 'sdrConversationService',
}
